import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=b043f49c"
import script from "./DeleteModal.vue?vue&type=script&lang=ts"
export * from "./DeleteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports